import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import StoreLogoComponent from '@prisjakt/ui-store-logo';
import TextLink from '@prisjakt/ui-text-link';
import { mobileLogoWidth } from '../../../constants';

export const ReviewsHeaderWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 ${layout.measurements.spacing100};
  padding-top: ${layout.measurements.spacing050};

  @supports (display: grid) {
    display: grid;
    grid-template-columns: 1fr 30%;
    row-gap: calc(0.5 * 0.57143rem);
    column-gap: calc(1 * 0.57143rem);
  }

  ${media.mediumDown`
    @supports (display: grid) {
      grid-template-columns: 1fr auto;
    }
  `}
`;

export const ButtonBack = styled(TextLink)`
  display: flex;
  align-items: center;
`;

export const StoreLogo = styled(StoreLogoComponent)`
  margin-bottom: ${layout.measurements.spacing050};

  ${media.smallOnly`
      max-width: ${mobileLogoWidth}px;
    `}
`;

export const TitleText = styled.h1`
  font-size: ${layout.fontSizes.h2.mobile.rem};
  margin: 0;
  margin-right: ${layout.measurements.spacing050};
`;

export const SotyBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
